export default __webpack_public_path__ + "static/media/3-icon.36ac2409.svg";